
import { defineComponent } from "vue";
import { mapState, mapActions } from "vuex";
import AppointmentForm from "./appointment/AppointmentForm.vue";
import PatientForm from "./patient/PatientForm.vue";
import PatientHistory from "./patient/PatientHistory.vue";

import { RECORD_TAB } from "@/common/constants";

export default defineComponent({
  name: "Record",
  components: { AppointmentForm, PatientForm, PatientHistory },
  data() {
    return {
      RECORD_TAB,
    };
  },
  computed: {
    ...mapState("record", ["patient_id", "active_tab"]),
  },
  methods: {
    closeModal(e: Event) {
      if (e.target == this.$refs.modal_mask) this.resetCloseNewAppointment();
    },
    ...mapActions({
      resetCloseNewAppointment: "record/resetAndClose",
      setActiveTab: "record/setActiveTab",
    }),
  },
});
